import axios from "axios";
import { toast } from "react-toastify";
import { PRINTER_SERVICE_HOST } from "../constants";

export const printReceipt = async (
  orderDetails,
  userInfo,
  printType = "automatic"
) => {
  console.log("printType");
  console.log(printType);
  console.log(orderDetails?.orderType);
  try {
    // selectedOutletId holds the outlet's _id; the outletId field is kept as
    // a fallback for outlet records that store it
    const selectedOutlet = userInfo?.outletId?.find(
      (oi) =>
        oi._id === userInfo?.selectedOutletId ||
        oi.outletId === userInfo?.selectedOutletId
    );
    if (!selectedOutlet) {
      throw new Error(
        "Selected outlet details not found, please log out and log in again"
      );
    }
    if (
      (selectedOutlet?.printOnlineOrder &&
        orderDetails?.orderType === "online") ||
      (selectedOutlet?.printOutletOrder &&
        orderDetails?.orderType === "outlet") ||
      printType === "manual"
    ) {
      const printPayload = {
        ...orderDetails,
        outletName: selectedOutlet.outletName,
        outletContact: selectedOutlet.outletContact,
        outletAddress: selectedOutlet.outletAddress,
        outletGstNumber: selectedOutlet.outletGstNumber,
        // Newly placed orders also get a kitchen receipt when the printer
        // service's kitchenPrint setting enables it; manual reprints omit
        // this flag so only the customer bill is printed
        ...(printType !== "manual" && { printKitchenReceipt: true }),
      };
      // Inside the desktop app the receipt goes through Electron, which
      // calls the printer service on this machine directly
      if (window.electronAPI?.printReceipt) {
        const response = await window.electronAPI.printReceipt(
          selectedOutlet?.printerServicePort,
          printPayload
        );
        console.log("Print response:", response);
      } else {
        const res = await axios.post(
          `http://${PRINTER_SERVICE_HOST}:${selectedOutlet?.printerServicePort}/printReceipt`,
          printPayload
        );
        console.log("Print response:", res.data);
      }
    }
  } catch (err) {
    // Prefer the printer service's message, which says whether the customer
    // bill or the kitchen receipt failed, over axios's generic status text
    const message = err.response?.data?.message || err.message;
    console.error("Print error:", message);
    toast.error(`Print error: ${message}`);
  }
};
